module.exports = __webpack_public_path__ + "static/rucar-2-a00e033dc39f9d923ba675c657e67d2b.jpg";